import { useState } from 'react';
import { Filter } from '../../../../types/catalog';

interface FilterAccordionProps extends Filter {
    toggleValue: (idx: number) => void;
    selected: string[];
    openDefault: boolean;
}

function FilterAccordion({ name, values, selected, toggleValue, openDefault }: FilterAccordionProps) {
    const [isOpen, setIsOpen] = useState(openDefault);
    return (
        <div
            className={
                'iek-prodcat-catalog-section-filter-block' +
                (isOpen ? '' : ' iek-prodcat-catalog-section-filter-block_collapsed')
            }
        >
            <table
                className="iek-prodcat-catalog-section-filter-block__title"
                onClick={() => setIsOpen(!isOpen)}
            >
                <tbody>
                    <tr>
                        <td className="iek-prodcat-catalog-section-filter-block__name-wrap">
                            <div className="iek-prodcat-catalog-section-filter-block__name">
                                <span className="iek-prodcat-catalog-section-filter-block__toggle" />
                                {name}
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>

            <div className="iek-prodcat-catalog-section-filter-values">
                {values.map((v, idx) => (
                    <label key={idx} className="iek-prodcat-catalog-section-filter-values__value-wrap">
                        <input
                            checked={selected.includes(v.value)}
                            onChange={() => toggleValue(idx)}
                            type="checkbox"
                        />
                        &nbsp;
                        <span className="iek-prodcat-catalog-section-filter-values__value">
                            {v.value}&nbsp;
                            <span className="iek-prodcat-catalog-section-filter-values__count">
                                ({v.productCount})
                            </span>
                        </span>
                    </label>
                ))}
            </div>
        </div>
    );
}

export default FilterAccordion;
